<template>
	<div class="login_box">
		<el-drawer v-model="drawerVisible" placement="right" size="680px" title="" append-to-body class="cart-drawer" @close="onClose">
			<template #header>
				<div class="flex items-center">
					<el-image style="width: 147px; height: 40px" :src="headerLogo" />
				</div>
			</template>

			<div class="relative login-container flex items-center justify-center bg-white px-4">
				<div class="login-card max-w-md">
					<!-- 登录Tab切换 -->
					<div class="tab-header flex justify-center mb-[17px] border-b-0">
						<el-tabs v-model="activeTab" class="login-tabs" tab-position="top" :tab-bar-style="{ borderBottom: 'none' }">
							<el-tab-pane name="password" :label="$t('uChoicePc.passwordLogin')"></el-tab-pane>
							<el-tab-pane name="email" :label="$t('uChoicePc.emailLogin')"></el-tab-pane>
							<el-tab-pane name="code" :label="$t('uChoicePc.codeLogin')"></el-tab-pane>
						</el-tabs>
					</div>

					<!-- 密码登录表单 -->
					<el-form v-if="activeTab !== 'code'" ref="pwdFormRef" class="password-login-form space-y-4" :model="passwordLoginForm" :rules="formRules" size="large">
						<!-- 手机号输入框 -->
						<el-form-item prop="phone" v-if="activeTab === 'password'">
							<el-input v-model="passwordLoginForm.phone" :placeholder="$t('uChoicePc.placeholderInput')" class="input_item_box flex-1 w-[100%] bg-[#F9F8F8]">
								<template #prepend>
									<el-select v-model="passwordLoginForm.phoneCountryCode" class="w-20" :placeholder="$t('uChoicePc.placeholderInput')">
										<el-option v-for="item in countryCodes" :key="item.code" :label="item.code" :value="item.code" />
									</el-select>
								</template>
							</el-input>
						</el-form-item>
						<!-- 邮箱 -->
						<el-form-item v-if="activeTab === 'email'" prop="email">
							<el-input v-model="passwordLoginForm.email" :placeholder="$t('uChoicePc.email')" class="input_item_box rounded-lg">
								<template #prefix>
									<img class="input__icon" :src="emilIcon" />
								</template>
							</el-input>
						</el-form-item>
						<!-- 密码输入框 + 忘记密码 -->
						<el-form-item class="relative" prop="password">
							<el-input v-model="passwordLoginForm.password" type="password" :placeholder="$t('uChoicePc.password')" class="input_item_box rounded-lg">
								<template #prefix>
									<img class="input__icon" :src="pwdIcon" />
								</template>
							</el-input>
							<span class="forget-password absolute right-4 top-1/2 -translate-y-1/2 text-[#F92863] cursor-pointer" @click="forgetPassword">
								{{ $t('uChoicePc.forgetPassword') }}
							</span>
						</el-form-item>

						<!-- 图形验证码 -->
						<el-form-item class="flex gap-2" prop="verificationCode">
							<el-input v-model="passwordLoginForm.verificationCode" :placeholder="$t('uChoicePc.verifyCode')" class="input_item_box rounded-2xl flex-1">
								<template #prefix>
									<img class="input__icon" :src="codeIcon" />
								</template>
							</el-input>
							<!-- 图形验证码 -->
							<div class="captcha-img w-30 h-14 flex items-center justify-center border rounded-2xl bg-gray-50 cursor-pointer select-none" @click="generateCaptcha">
								<span v-for="(char, index) in captchaChars" :key="index" :style="{ color: captchaColors[index] }" class="text-[28px] font-bold">{{ char }}</span>
							</div>
						</el-form-item>

						<!-- 登录按钮 -->
						<el-form-item>
							<el-button type="primary" class="w-full rounded-2xl bg-[#F92863] hover:bg-[#D8004E] border-0 h-12 text-lg" @click="handlePasswordLogin">
								{{ $t('uChoicePc.login') }}
							</el-button>
						</el-form-item>
					</el-form>

					<!-- 验证码登录表单 -->
					<el-form ref="registerFormRef" v-if="activeTab === 'code'" class="code-login-form space-y-4" :model="codeLoginForm" :rules="formRules" size="large">
						<!-- 邮箱输入框 -->
						<el-form-item prop="email">
							<el-input v-model="codeLoginForm.email" :placeholder="$t('uChoicePc.email')" class="input_item_box rounded-lg">
								<template #prefix>
									<img class="input__icon" :src="emilIcon" />
								</template>
							</el-input>
						</el-form-item>

						<!-- 验证码 + 获取按钮 -->
						<el-form-item class="relative" prop="verificationCode">
							<el-input v-model="codeLoginForm.verificationCode" :placeholder="$t('uChoicePc.verifyCode')" class="input_item_box rounded-lg">
								<template #prefix>
									<img class="input__icon" :src="codeIcon" />
								</template>
								<template #suffix>
									<el-button class="bg-transparent hover:bg-transparent" text :disabled="countdown > 0" @click="handleGetCode">
										<span :class="[countdown <= 0 ? 'text-[#F92863]' : '']">
											{{ countdown > 0 ? `${countdown}${$t('uChoicePc.countdownText')}` : $t('uChoicePc.getCode') }}</span
										>
									</el-button>
								</template>
							</el-input>
						</el-form-item>

						<!-- 登录按钮 -->
						<el-form-item>
							<el-button type="primary" class="w-full rounded-2xl bg-[#F92863] hover:bg-[#D8004E] border-0 h-12 text-[18px]" @click="handleCodeLogin">
								{{ $t('uChoicePc.login') }}
							</el-button>
						</el-form-item>
					</el-form>
					<!-- 去注册 -->
					<div class="mt-[16px] w-[100%] text-center">
						<span class="text-gray-500">{{ $t('uChoicePc.noAccount') }}</span>
						<span class="text-[#F92863] ml-1 cursor-pointer" @click="goRegister">{{ $t('uChoicePc.goRegister') }}</span>
					</div>
				</div>
			</div>
		</el-drawer>
		<!-- 注册 -->
		<register-dialog ref="registerDialogRef"></register-dialog>
		<!-- 忘记密码 -->
		<forget-pwd ref="forgetPwdRef"></forget-pwd>

		<inline-message ref="msgRef" />
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { setToken } from '@/utils/auth'
import { setStore } from '@/utils/store'
import { ElMessage, type FormInstance, type FormRules } from 'element-plus'
import lang from '@/lang/index'
import registerDialog from '@/views/mall/components/register-dialog/index.vue'
import InlineMessage from '@/views/mall/components/inline-message/index.vue'
import forgetPwd from '@/views/mall/components/forget-pwd/index.vue'
import { getEmilCode, getSelectorNoAuth, loginSave } from '@/api/mall/index'
import useUserStore from '@/store/user'

const userStore = useUserStore()
const i18n = lang.global
const drawerVisible = ref(false)

// 激活的Tab（password:密码登录，code:验证码登录）
const activeTab = ref('password')
const headerLogo = new URL(`@/assets/img/header_logo.png`, import.meta.url).href
const pwdIcon = new URL(`@/assets/img/logo/logo_icon_pwd.png`, import.meta.url).href
const codeIcon = new URL(`@/assets/img/logo/logo_icon_code.png`, import.meta.url).href
const emilIcon = new URL(`@/assets/img/logo/logo_icon_emil.png`, import.meta.url).href

// 图形验证码
const captchaChars = ref<string[]>([])
const captchaColors = ref<string[]>([])
const CHAR_POOL = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const COLOR_POOL = ['#2563EB', '#DC2626', '#16A34A', '#EA580C', '#7C3AED', '#DB2777', '#0891B2', '#4F46E5']

// 生成图形验证码
const generateCaptcha = () => {
	const chars: string[] = []
	const colors: string[] = []
	for (let i = 0; i < 4; i++) {
		chars.push(CHAR_POOL[Math.floor(Math.random() * CHAR_POOL.length)])
		colors.push(COLOR_POOL[Math.floor(Math.random() * COLOR_POOL.length)])
	}
	captchaChars.value = chars
	captchaColors.value = colors
}
const registerDialogRef = ref()
const goRegister = () => {
	registerDialogRef.value.open()
}

onMounted(() => {
	generateCaptcha()
})
onBeforeUnmount(() => {
	if (timer) clearInterval(timer)
})

const open = () => {
	drawerVisible.value = true
	getSysType()
}

const countryCodes = ref<any[]>([])
// 获取国家编码
const getSysType = () => {
	const params: any = {
		type: 'DICT_DATA',
		business: 'countryCode'
	}
	getSelectorNoAuth(params)
		.then((res: any) => {
			countryCodes.value = res.data || []
		})
		.catch(() => {})
}
// 验证码倒计时
const countdown = ref(0)
let timer: number | null = null
// 表单DOM引用
const registerFormRef = ref<FormInstance | null>(null)
// 获取验证码
const handleGetCode = () => {
	// 先校验邮箱
	registerFormRef.value?.validateField('email', (valid) => {
		if (!valid) return
		const params: any = {
			email: codeLoginForm.value.email
		}
		getEmilCode(params).then(() => {
			ElMessage.success(i18n.t('uChoicePc.codeSendSuccess'))
			// 开启60秒倒计时
			countdown.value = 60
			timer = window.setInterval(() => {
				countdown.value--
				if (countdown.value <= 0) {
					clearInterval(timer!)
				}
			}, 1000)
		})
	})
}

// 表单校验规则
const formRules = reactive<FormRules>({
	phone: [
		{ required: true, message: i18n.t('uChoicePc.phoneRuleTip'), trigger: 'blur' },
		{ pattern: /^\d{6,15}$/, message: i18n.t('uChoicePc.phoneRuleTip'), trigger: 'blur' }
	],
	email: [
		{ required: true, message: i18n.t('uChoicePc.emailRuleTip'), trigger: 'blur' },
		{ type: 'email', message: i18n.t('uChoicePc.emailRuleTip'), trigger: 'blur' }
	],
	password: [{ required: true, message: i18n.t('uChoicePc.pleaseEnterPassword'), trigger: 'blur' }],
	verificationCode: [{ required: true, message: i18n.t('uChoicePc.pleaseEnterTureCode'), trigger: 'blur' }]
})

// 密码登录表单数据
const passwordLoginForm = ref({
	phoneCountryCode: '+86',
	phoneOrEmail: '', // 邮箱/手机号
	password: '', // 密码
	verificationCode: '', // 图形验证码
	phone: '',
	email: ''
})

// 验证码登录表单数据
const codeLoginForm = ref({
	email: '', // 邮箱
	verificationCode: '' // 验证码
})
const msgRef = ref<InstanceType<typeof InlineMessage>>()
const pwdFormRef = ref<FormInstance | null>(null)
// 密码登录处理
const handlePasswordLogin = async () => {
	// 模拟登录逻辑
	if (activeTab.value === 'password') {
		if (!passwordLoginForm.value.phone) {
			msgRef.value?.show(i18n.t('uChoicePc.phone') + i18n.t('uChoicePc.required'), 'error')
			return
		}
		passwordLoginForm.value.phoneOrEmail = passwordLoginForm.value.phone
	}
	if (activeTab.value === 'email') {
		if (!passwordLoginForm.value.email) {
			msgRef.value?.show(i18n.t('uChoicePc.email') + i18n.t('uChoicePc.required'), 'error')
			return
		}
		passwordLoginForm.value.phoneOrEmail = passwordLoginForm.value.email
	}
	if (!passwordLoginForm.value.password) {
		msgRef.value?.show(i18n.t('uChoicePc.password') + i18n.t('uChoicePc.required'), 'error')
		return
	}
	if (!passwordLoginForm.value.verificationCode) {
		msgRef.value?.show(i18n.t('uChoicePc.verifyCode') + i18n.t('uChoicePc.required'), 'error')
		return
	}
	// 校验图形验证码（英文字母不区分大小写）
	if (captchaChars.value.join('').toUpperCase() !== passwordLoginForm.value.verificationCode.toUpperCase()) {
		msgRef.value?.show(i18n.t('uChoicePc.pleaseEnterTureCode'), 'error')
		return
	}
	if (!pwdFormRef.value) return
	await pwdFormRef.value.validate((valid) => {
		if (valid) {
			save(passwordLoginForm.value)
		}
	})
}

// 验证码登录处理
const handleCodeLogin = () => {
	// 模拟登录逻辑
	if (!codeLoginForm.value.email) {
		msgRef.value?.show(i18n.t('uChoicePc.email') + i18n.t('uChoicePc.required'), 'error')
		return
	}
	if (!codeLoginForm.value.verificationCode) {
		msgRef.value?.show(i18n.t('uChoicePc.verifyCode') + i18n.t('uChoicePc.required'), 'error')
		return
	}
	save(codeLoginForm.value)
}

const save = (params: any) => {
	// 登录方式(0手机号密码，1邮箱密码，2邮箱验证码)
	const obj: any = {
		password: 0,
		email: 1,
		code: 2
	}
	params.loginMode = obj[activeTab.value]
	loginSave(params)
		.then(async (res: any) => {
			if (res.code !== 200) {
				msgRef.value?.show(res.msg, 'error')
				return
			}
			if (!res.data?.token || !res.data?.memberInfo) {
				msgRef.value?.show(i18n.t('uChoicePc.networkError'), 'error')
				return
			}
			setToken(res.data.token)
			setStore({ name: 'loginInfo', content: res.data.memberInfo })
			userStore.setUserInfo(res.data.memberInfo)
			await userStore.getCartQuantity()
			onClose()
			location.reload()
		})
		.catch(() => {
			msgRef.value?.show(i18n.t('uChoicePc.networkError'), 'error')
		})
}
const onClose = () => {
	userStore.setUpdateLogin()
}
const forgetPwdRef = ref()
const forgetPassword = () => {
	forgetPwdRef.value.openDialog()
}

defineExpose({
	open
})
</script>

<style scoped lang="scss">
.cart-drawer {
	border-radius: 16px 0px 0px 16px !important;
	overflow: hidden;
}
/* 补充少量定制样式，UnoCSS覆盖大部分 */
.login-container {
	height: 100%;
	.login-card {
		width: 400px;
		height: 448px;
	}
}
.login-tabs :deep(.el-tabs__nav-wrap) {
	justify-content: center;
}
.login-tabs :deep(.el-tabs__active-bar) {
	display: none;
	// background-color: #f92863;
	// width: 40px !important;
	// margin: 0 auto;
}
.login-tabs :deep(.el-tabs__item) {
	position: relative;
	font-size: 20px;
	padding: 0 20px;
}
.login-tabs :deep(.el-tabs__item.is-active) {
	color: #000;
	font-weight: bold;
	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		// left: 50%;
		// transform: translateX(-50%);
		width: 32px;
		height: 4px;
		background-color: #f92863;
		border-radius: 16px 16px 0 0;
		display: inline-block;
	}
}
.forget-password {
	font-size: 16px;
}
.captcha-img {
	margin-left: 8px;
	user-select: none;
}

.input__icon {
	width: 18px;
}

.login-card {
	:deep(.el-form-item__content) {
		line-height: 56px;
		border-radius: 16px;
		overflow: hidden;
	}
	:deep(.el-input) {
		height: 56px;
	}
	:deep(.el-input__wrapper) {
		border-radius: 16px;
	}
	:deep(.input__icon) {
		width: 24px;
		height: 24px;
	}
	:deep(div) {
		font-size: 16px;
	}
	:deep(.el-tabs__nav-wrap::after) {
		background-color: transparent;
	}
	:deep(.el-form-item--large) {
		margin-bottom: 16px;
	}
}
</style>
